import { render, staticRenderFns } from "./liveblog.vue?vue&type=template&id=569438aa&scoped=true&"
import script from "./liveblog.vue?vue&type=script&lang=js&"
export * from "./liveblog.vue?vue&type=script&lang=js&"
import style0 from "./liveblog.vue?vue&type=style&index=0&id=569438aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "569438aa",
  null
  
)

export default component.exports